import { path } from './helpers'
import Vue from 'vue'

let api = () => Vue.prototype.$api

class MicrohabitRepository {
	constructor (type) {
		this.type = type
	}

	getMicrohabitCategory (categoryId) {
		return api().get(`${path('microhabits/categories')}/${categoryId}`)
	}

	getMicrohabitCategories () {
		return api().get(path('microhabits/categories'), { params: { type: this.type } })
	}

	getMicrohabit (microhabitId) {
		return api().get(`${path('microhabits')}/${microhabitId}`)
	}

	getMicrohabits (category = null) {
		return api().get(`${path('microhabits')}`, {
			params: {
				categoryId : category,
				type: this.type
			}
		})
	}

	getPatientMicrohabits (categoryId = null, microhabitId = null) {
		return api().get(`${path('patient/microhabits')}`, {
			params: {
				categoryId,
				microhabitId,
				type: this.type
			}
		})
	}

	addPatientMicrohabit (patientMicrohabit) {
		patientMicrohabit.type = this.type
		return api().post(`${path('patient/microhabits')}`, patientMicrohabit)
	}

	updatePatientMicrohabit (patientMicrohabit) {
		patientMicrohabit.type = this.type
		return api().put(`${path('patient/microhabits')}`, patientMicrohabit)
	}

	deletePatientMicrohabit (patientMicrohabitId, deleteHabit = false) {
		return api().delete(`${path('patient/microhabits')}/${patientMicrohabitId}`, { params: { deleteHabit, type: this.type }})
	}
}

export default MicrohabitRepository


// WEBPACK FOOTER //
// ./src/repositories/MicrohabitsRepository.js